import { render, staticRenderFns } from "./SingleSignOn.vue?vue&type=template&id=d1b63ec4&scoped=true"
import script from "./SingleSignOn.vue?vue&type=script&lang=js"
export * from "./SingleSignOn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b63ec4",
  null
  
)

export default component.exports